module.exports = __webpack_public_path__ + "static/Windi Romania-39532894b2f688ee4369c7774547fbff.jpeg";